<template>
  <div class="main">
    <Header 
      :show="true"
      title="修改推送人群"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
      wrapable
      :scrollable="false"
      text="请选择需要推送的人，支持多选"
    />
    <van-form 
      ref="update"
      @submit="submit"
    >
      <van-collapse v-model="activeNames">
        <van-collapse-item 
          v-for="item in departmentOptions"
          :key="item.serial"
          :title="item.name" 
          :name="item.serial"
        >
          <van-checkbox-group v-model="checkboxGroup" direction="horizontal">
            <van-checkbox 
              v-for="member in item.members"
              :key="member.serial" 
              :name="member.serial" 
              shape="square"
              @click="handleClickCheckboxGroup(member)"
            >
              {{ member.name }}
            </van-checkbox>
          </van-checkbox-group>
        </van-collapse-item>
      </van-collapse>
        <div style="margin: .6rem 1rem;" v-if="checkPermission([112])">
          <van-button round block type="info" native-type="submit">
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { isUserName, isPassword, isChinese, isPhone, isEmail } from '@/utils/validate.js'
  import { getList as getStaffList } from '@/api/staff.js'
  import { getList as getDepartmentList } from '@/api/department.js'
  import { updateOne } from '@/api/message.js'

  export default {
    name: 'SystemProductLineUpdate',
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        isLoading: false,
        loading: false,
        listQuery: {
          limit: 10,
          page: 1,
          serial: null,
          title: '',
          members: [],
          remark: ''
        },
        activeNames: [],
        checkboxGroup: [],
        staffOptions: [],
        departmentOptions: []
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleGetDepartmentList()
    },
    beforeMount() {
      
    },
    mounted() {
      this.listQuery = this.$route.query
      this.checkboxGroup = this.$route.query.members.split('|')
      this.checkboxGroup = this.checkboxGroup.map(Number)
      this.listQuery.serial = parseInt(this.$route.query.serial, 10)
      this.listQuery.title = this.$route.query.name
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$refs.update.submit()
      },
      submit() {
        let wxworkList = []
        for (let i=0; i<this.checkboxGroup.length; i++) {
          for (let j=0; j<this.staffOptions.length; j++) {
            if (this.checkboxGroup[i] === this.staffOptions[j].serial) {
              wxworkList.push(this.staffOptions[j].wxwork)
            }
          }
        }
        Dialog.confirm({
          title: '确定修改消息推送人群设定？',
          message: '消息：' + this.listQuery.title
        }).then(() => {
          this.loading = true
          const data = {
            id: this.listQuery.serial,
            value: wxworkList.join('|'),
            remark: this.listQuery.remark
          }
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '更新消息推送', data.message)) {
              this.$router.push({ path:'/service/project/message', query: {} })
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, '修改装车线', '取消')
        })
      },
      handleClickCheckboxGroup(member) {

      },
      handleGetStaffList() {
        const data = {
          page: 1,
          limit: 10000
        }
        getStaffList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.staffOptions = []
            for (let i=0; i<items.length; i++) {
              if (items[i].wxwork !== '') {
                this.staffOptions.push({
                  serial: items[i].id,
                  name: items[i].name,
                  wxwork: items[i].wxwork
                })
                for (let j=0; j<this.departmentOptions.length; j++) {
                  if (items[i].department === this.departmentOptions[j].name) {
                    this.departmentOptions[j].members.push({
                      serial: items[i].id,
                      name: items[i].name,
                      wxwork: items[i].wxwork
                    })
                  }
                }
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleGetDepartmentList() {
        const data = {
          page: 1,
          limit: 1000
        }
        getDepartmentList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.departmentOptions = []
            for (let i=0; i<items.length; i++) {
              this.departmentOptions.push({
                id: i + 1,
                serial: items[i].id,
                name: items[i].name,
                remark: items[i].remark,
                members: []
              })
              this.activeNames.push(items[i].id)
            }
            this.handleGetStaffList()
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改
  ::v-deep .van-field__label {
    width: 5em;
  }
  ::v-deep .van-field__control:read-only {
    color: #999;
  }
  ::v-deep .van-checkbox {
    padding: 3px 0;
  }
  ::v-deep .van-checkbox__icon {
    font-size: 4.5vw;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F8F8F8; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
